import React, { useEffect, useState } from "react";
import { Text, View } from "react-native";
import { FormattedMessage, useIntl } from "react-intl";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { If, Then, Else, When } from "react-if";
import HeaderTabs from "../../components/HeaderTabs";
import ScreenLoader from "../../components/ScreenLoader";
import api from "../../services/api";
import { TouchableOpacity } from "react-native-gesture-handler";
import balanceService from "../../services/balanceService";
import feeService from "../../services/feeService";
import { useNavigation } from "@react-navigation/native";

import {
  formatCoin,
  formatGPXBalance,
  maxDecimals,
} from "../../utils/formatNumber";
import styles from "./styles";

/*
 * ROUTE PARAMS -> qtd (float), token (actives.activeId), viewType(buy|sell), market (optional:true|false,default:false)
 */

const ConfirmPurchaseOrSell = (props, objParam) => {
  const [uri, setUri] = useState("../../../assets/imgs/gpx.png");
  const [nameToken, setNameToken] = useState("GPX");
  const [valueToken, setValueToken] = useState(1);
  const [qtd, setQtd] = useState(1);
  const [price, setPrice] = useState(0);
  const [viewType, setViewType] = useState("buy");
  const [market, setMarket] = useState(false);
  const [customTokenValue, setCustomTokenValue] = useState(0);
  const [activeIdTokenId, setActiveIdTokenId] = useState();
  const [activeIdTokenObj, setActiveIdTokenObj] = useState();
  const [balance, setBalance] = useState(0); // Buy -> GPX/BRL Balance || Sell -> Active/Token Balance
  const [authToken, setAuthToken] = useState();
  const [fee, setFee] = useState({
    fee: 0.1,
    type: "fixed",
  });
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [clientCountry, setClientCountry] = useState("");
  const intl = useIntl();
  const navigation = useNavigation();

  const goBackFromConfirmPurchaseOrSell = () => {
    /*    navigation.navigate("Purchase", {
      fromConfirmPurchaseOrSell: true,
    }); */
    navigation.goBack();
  };

  useEffect(() => {
    loadTokenAndRequest();
  }, [viewType]);

  useEffect(() => {
    setLoading1(true);

    const { qtd, token, viewType, market, customTokenValue, price } =
      props.route.params;

    setQtd(qtd || 1);
    setActiveIdTokenId(token || null);
    setViewType(viewType || null);
    setMarket(market || false);
    setCustomTokenValue(customTokenValue || null);
    setPrice(price || 0);

    setLoading1(false);
  }, []);

  useEffect(() => {
    getDataCoin();
  }, [activeIdTokenId]);

  useEffect(() => {
    if (authToken) {
      loadBalance();
      loadFees();
    }
  }, [authToken]);

  const loadTokenAndRequest = async () => {
    const authTokenStorage = await AsyncStorage.getItem("JWT_TOKEN");
    setAuthToken(authTokenStorage);
  };

  const getClientCountry = async () => {
    const country = await AsyncStorage.getItem("client_country");
    setClientCountry(country || "");
  };

  useEffect(() => {
    getClientCountry();
  }, []);

  const loadBalance = async () => {
    if (authToken) {
      try {
        if (viewType === "buy") {
          const { data } = await balanceService.getBalanceOfGpx(authToken);
          if (data?.balance?.length > 0) {
            setBalance(data?.balance[0].available_balance + "");
          }
        } else if (viewType === "sell" && activeIdTokenId) {
          const { data } = await balanceService.getBalanceOfToken(
            authToken,
            activeIdTokenId
          );
          setBalance(data?.saldo + "");
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const getDataCoin = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    setLoading3(true);
    try {
      const { data } = await api.get(`/actives/${activeIdTokenId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (data.actives.length > 0) {
        setActiveIdTokenObj(data.actives[0]);
        setNameToken(data.actives[0].name_token);
        setUri(
          `https://filesgpx.s3.us-east-2.amazonaws.com/${data.actives[0].path}`
        );
        if (price) {
          setValueToken(price);
        } else {
          customTokenValue > 0
            ? setValueToken(customTokenValue)
            : setValueToken(data.actives[0].single_value); //TODO: Implementar valores fixos e flutuantes -> BUG
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading3(false);
    }
  };
  const loadFees = () => {
    if (authToken) {
      setLoading2(true);
      if (viewType === "buy") {
        if (market) {
          feeService
            .getExchangeBuyFeeByActiveId(authToken, activeIdTokenId)
            .then((response) => {
              if (response.status === 200) {
                setFee(response.data);
              } else {
                console.error("Unable to load fee.");
              }
              setLoading2(false);
            })
            .catch((error) => {
              setLoading2(false);
              console.error(error);
            });
        } else {
          feeService
            .getMarketplaceBuyFeeByActiveId(authToken, activeIdTokenId)
            .then((response) => {
              if (response.status === 200) {
                if (clientCountry === "italia") {
                  setFee(0);
                } else {
                  setFee(response.data);
                }
              } else {
                console.error("unable to load fee");
              }
              setLoading2(false);
            })
            .catch((error) => {
              setLoading2(false);
              console.error(error);
            });
        }
      } else {
        feeService
          .getExchangeSellFeeByActiveId(authToken, activeIdTokenId)
          .then((response) => {
            if (response.status === 200) {
              setFee(response.data);
            } else {
              console.error("unable to load fee");
            }
            setLoading2(false);
          })
          .catch((error) => {
            setLoading2(false);
            console.error(error);
          });
      }
    }
  };

  //compra
  //criptoativo
  //Saldo em GPX para cobrir a compra
  //Taxa é descontada em criptomoeda do valor a receber após compra em tokens
  //Valor a receber é compra - taxa
  //não criptoativo
  //Saldo em GPX para cobrir a compra
  //Saldo em GPX para cobrir a taxa
  //venda
  //criptoativo
  //saldo só em tokens
  //taxa % ou fixa descontada do valor a receber em GPX
  // volume mínimo de compra é igual a taxa + alguma coisa
  //não criptoativo
  //necessário saldo em tokens
  //taxa % ou fixa descontada do valor a receber em GPX
  const getCurrentFee = () => {
    if (clientCountry === "italia") {
      return 0; // Taxa zero para clientes da Itália
    }

    // Demais cálculos de taxa continuam normais
    if (activeIdTokenObj?.cryptoactive && fee.type) {
      if (viewType === "buy") {
        return formatCoin(
          fee.type === "fixed"
            ? fee.fee
            : parseFloat(fee.fee) * parseFloat(qtd),
          activeIdTokenObj.feezeroMk
        );
      } else {
        return parseFloat(
          fee.type === "fixed"
            ? parseFloat(fee.fee) * parseFloat(valueToken)
            : parseFloat(fee.fee) * parseFloat(valueToken) * parseFloat(qtd)
        );
      }
    } else if (fee.type) {
      return parseFloat(
        fee.type === "fixed"
          ? fee.fee
          : parseFloat(fee.fee) * parseFloat(qtd) * parseFloat(valueToken)
      );
    }
  };

  const getCurrentFeeLabel = () => {
    let feeTmp = getCurrentFee();
    const formatoMoeda = intl.formatMessage({
      id: "confirmPurchaseOrSell.simboloMoeda",
    });

    if (clientCountry === "italia") {
      return "0 " + formatoMoeda;
    }

    if (fee.currency == "active" && activeIdTokenObj) {
      if (viewType === "buy")
        return maxDecimals(feeTmp, 8) + " " + activeIdTokenObj.name_token;
      else return formatGPXBalance(feeTmp, 8) + " " + formatoMoeda;
    } else {
      return formatGPXBalance(feeTmp) + " " + formatoMoeda;
    }
  };

  const minGpxBalance = () => {
    if (viewType == "buy") {
      if (clientCountry === "italia") {
        // Se o país do cliente for Itália, a taxa é 0
        return qtd * valueToken;
      }

      if (activeIdTokenObj?.cryptoactive && fee.type) {
        return qtd * valueToken + getCurrentFee(); // Inclui taxa se não for Itália
      } else if (fee.type) {
        return qtd * valueToken + getCurrentFee();
      }
    } else {
      if (activeIdTokenObj?.cryptoactive && fee.type) {
        return 0; // venda de criptoativo sem taxas
      } else if (fee.type) {
        return 0; // venda normal sem taxas
      }
    }
  };

  const minTokenBalance = () => {
    if (viewType == "buy") {
      return 0;
    } else {
      return qtd;
    }
  };

  return (
    <>
      <ScreenLoader loading={loading1 || loading2 || loading3} />
      <HeaderTabs
        title={
          viewType === "buy" ? (
            <FormattedMessage id="confirmPurchaseOrSell.confirmarCompra" />
          ) : (
            <FormattedMessage id="confirmPurchaseOrSell.confirmarVenda" />
          )
        }
      />

      <View style={styles.container}>
        <View style={styles.card}>
          <Text style={styles.title}>
            <FormattedMessage id="confirmPurchaseOrSell.msgVoceConfirma" />{" "}
            <If condition={viewType === "buy"}>
              <Then>
                <FormattedMessage id="confirmPurchaseOrSell.compra" />
              </Then>
              <Else>
                <FormattedMessage id="confirmPurchaseOrSell.venda" />
              </Else>
            </If>
            <FormattedMessage id="confirmPurchaseOrSell.abaixo" />
          </Text>

          <View style={styles.containerCompra}>
            <Text style={styles.lbl}>
              <If condition={viewType === "buy"}>
                <Then>
                  <FormattedMessage id="confirmPurchaseOrSell.compra" />
                </Then>
                <Else>
                  <FormattedMessage id="confirmPurchaseOrSell.venda" />
                </Else>
              </If>
            </Text>

            <Text style={styles.lbl}>
              <FormattedMessage id="confirmPurchaseOrSell.valor" />
            </Text>
          </View>
          <View style={styles.subtitle}>
            <Text style={styles.textDescription}>{nameToken}</Text>
            <Text style={styles.textValue}>
              {valueToken}{" "}
              <FormattedMessage id="confirmPurchaseOrSell.txtGpxBrl" />
            </Text>
          </View>

          <View style={styles.contentCard}>
            <View style={styles.descriptionElements}>
              <Text style={styles.textDescription}>
                <FormattedMessage id="confirmPurchaseOrSell.saldo" />
              </Text>
              <Text style={styles.textValue}>
                <If condition={viewType === "buy"}>
                  <Then>{formatGPXBalance(balance)}</Then>
                  <Else>{balance} </Else>
                </If>

                {activeIdTokenObj?.name_token &&
                  (viewType === "buy" ? (
                    <FormattedMessage id="confirmPurchaseOrSell.GpxSifrao" />
                  ) : (
                    activeIdTokenObj.name_token
                  ))}
              </Text>
            </View>
            {activeIdTokenObj?.cryptoactive && viewType === "sell" && (
              <View style={styles.descriptionElements}>
                <Text style={styles.textDescription}>
                  <FormattedMessage id="confirmPurchaseOrSell.saldoPosTransacao" />
                </Text>
                <Text style={styles.textValue}>
                  {activeIdTokenObj?.cryptoactive
                    ? maxDecimals(parseFloat(balance - qtd), 8) +
                      " " +
                      activeIdTokenObj?.name_token
                    : formatGPXBalance(parseFloat(balance - qtd)) +
                      " " +
                      activeIdTokenObj?.name_token}
                </Text>
              </View>
            )}
            <View style={styles.descriptionElements}>
              <Text style={styles.textDescription}>
                <FormattedMessage id="confirmPurchaseOrSell.valorTransacao" />
              </Text>
              <Text style={styles.textValue}>
                {formatGPXBalance(parseFloat(qtd * valueToken))}{" "}
                <FormattedMessage id="confirmPurchaseOrSell.txtGpxBrl" />
                {/*activeIdTokenObj?.name_token && (viewType === 'buy' ? 'GPX' : activeIdTokenObj.name_token)*/}
              </Text>
            </View>
            {!activeIdTokenObj?.cryptoactive && (
              <View style={styles.descriptionElements}>
                <Text style={styles.textDescription}>
                  <FormattedMessage id="confirmPurchaseOrSell.taxa" />
                </Text>
                <Text style={styles.textValue}>{getCurrentFeeLabel()}</Text>
              </View>
            )}
            <View style={styles.descriptionElements}>
              <Text style={styles.textDescription}>
                <If condition={viewType === "buy"}>
                  <Then>
                    <FormattedMessage id="withdrawgpx.valorReceber" />
                  </Then>
                  <Else>
                    <FormattedMessage id="confirmPurchaseOrSell.totalReceber" />
                  </Else>
                </If>
              </Text>
              <Text style={styles.textValue}>
                {viewType === "buy"
                  ? activeIdTokenObj?.cryptoactive
                    ? formatGPXBalance(
                        parseFloat(
                          qtd * valueToken + parseFloat(getCurrentFee())
                        )
                      )
                    : formatGPXBalance(
                        parseFloat(
                          qtd * valueToken + parseFloat(getCurrentFee())
                        )
                      )
                  : formatGPXBalance(
                      parseFloat(qtd * valueToken - getCurrentFee())
                    )}{" "}
                <FormattedMessage id="confirmPurchaseOrSell.txtGpxBrl" />
              </Text>
            </View>
            {activeIdTokenObj?.cryptoactive && (
              <View style={styles.descriptionElements}>
                <Text style={styles.textDescription}>
                  <FormattedMessage id="confirmPurchaseOrSell.taxa" />
                </Text>
                <Text style={styles.textValue}>{getCurrentFeeLabel()}</Text>
              </View>
            )}
            <When condition={viewType === "buy"}>
              <If condition={activeIdTokenObj?.cryptoactive}>
                <Then>
                  <View style={styles.descriptionElements}>
                    <Text style={styles.textDescription}>
                      <FormattedMessage id="confirmPurchaseOrSell.totalReceber" />
                    </Text>
                    <Text style={styles.textValue}>
                      {maxDecimals(parseFloat(qtd - getCurrentFee()), 8) +
                        " " +
                        activeIdTokenObj?.name_token}
                    </Text>
                  </View>
                </Then>
                <Else>
                  <View style={styles.descriptionElements}>
                    <Text style={styles.textDescription}>
                      <FormattedMessage id="confirmPurchaseOrSell.saldoPosTransacao" />
                    </Text>
                    <Text style={styles.textValue}>
                      {formatGPXBalance(
                        balance -
                          parseFloat(
                            qtd * valueToken + getCurrentFee()
                          ).toFixed(2)
                      )}{" "}
                      <FormattedMessage id="confirmPurchaseOrSell.txtGpxBrl" />
                    </Text>
                  </View>
                </Else>
              </If>
            </When>
          </View>

          <If
            condition={
              clientCountry === "brasil" &&
              qtd * objParam.price < 11 /* || qtd * customTokenValue < 11 */
            }
          >
            <Then>
              <View style={styles.containerErro}>
                <Text style={styles.erroMinimo}>
                  <FormattedMessage id="confirmPurchaseOrSell.erroMinimoNecessario" />
                </Text>
              </View>
            </Then>
            <Else>
              <If
                condition={
                  balance <
                  (viewType === "sell" ? minGpxBalance() : minTokenBalance())
                }
              >
                <Then>
                  <TouchableOpacity
                    route={"DepositMethod"}
                    props={{}}
                    style={styles.btn}
                  >
                    <FormattedMessage id="purchase.saldoInsuficiente" />
                  </TouchableOpacity>
                </Then>
                <Else>
                  <TouchableOpacity
                    style={styles.btn}
                    onPress={() =>
                      props.navigation.navigate({
                        name: "ConfirmPasswordPurchaseOrSell",
                        params: {
                          purchase: viewType === "buy",
                          qtd: qtd,
                          valueToken: valueToken,
                          token: activeIdTokenId,
                          market: market,
                        },
                      })
                    }
                  >
                    <Text style={styles.textBtn}>
                      <FormattedMessage id="confirmPurchaseOrSell.btnConfirmar" />
                    </Text>
                  </TouchableOpacity>
                </Else>
              </If>
            </Else>
          </If>
          <When
            condition={
              qtd * valueToken >= 11 &&
              balance <=
                (viewType === "buy" ? minGpxBalance() : minTokenBalance())
            }
          ></When>

          <TouchableOpacity
            onPress={goBackFromConfirmPurchaseOrSell}
            style={styles.btnVoltar}
          >
            <Text style={styles.btnVoltarText}>
              <FormattedMessage id="goBackButton.labelVoltar" />
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </>
  );
};

export default ConfirmPurchaseOrSell;
